<template>
  <section class="header-postmatch">
    <div class="header-postmatch__cont-date">
      <HeaderDate :headerDate="headerDate" :live="live" :matchlapse="matchlapse" />
    </div>

    <div class="header-postmatch__cont-data-game">
      <HeaderPostmatchGame :headerInfoPostMatch="headerInfoPostMatch" />
    </div>
    <div class="header-postmatch__cont-data-referee">
      <HeaderPostmatchReferee :headerInfoPostMatch="headerInfoPostMatch" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeaderPostMatch',
  components: {
    HeaderPostmatchGame: () => import('@/components/ActiveTime/Elements/ReportSections/Elements/HeaderPostmatchGame'),
    HeaderPostmatchReferee: () =>
      import('@/components/ActiveTime/Elements/ReportSections/Elements/HeaderPostmatchReferee'),
    HeaderDate: () => import('@/components/ActiveTime/Elements/ReportSections/Elements/HeaderDate'),
  },
  props: {
    headerDate: {
      type: Object,
      required: true,
    },
    headerInfoPostMatch: {
      type: Object,
      required: true,
    },
    live: {
      type: Number,
      default: 0,
      required: true,
    },
    matchlapse: {
      type: Number,
      default: -1,
      required: true,
    },
  },
  computed: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
<style lang="scss" scoped>
.header-postmatch {
  width: 100%;
  height: auto;
  &__cont-date {
    @media screen and (max-width: 830px) {
      display: no;
    }
  }
}
</style>
